import {gql} from "@apollo/client";
import {NoContactInput} from "../../domain";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";


const GRAPHQL_MUTATION = gql`
mutation submitAuthNoContact($input: NoContactResponseInput) {
    submitAuthNoContact(input: $input) {
        guid
    }
}`;

type AuthNoContactInput = NoContactInput & {
    authorizationGuid: string;
}

export function useAuthNoContact(authorizationGuid: string) {
    const {execute,} = useMutation$<{ input: AuthNoContactInput }, void>(GRAPHQL_MUTATION);
    const submitAuthNoContact = useCallback(async function (formValues: NoContactInput | null) {
        if (formValues == null) {
            return;
        }

        try {
            await execute({
                variables: {
                    input: {
                        ...formValues,
                        authorizationGuid,
                    },
                }
            });
            showToast.success(
                'No Contact request successfully submitted. The Request can be tracked in the "Submitted Requests" section and a request number ID will be available shortly.'
            );
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit reason by ${errors.message || errors[0].message}`);
            }
        }
    }, [authorizationGuid, execute]);

    return {
        submitAuthNoContact
    }
}
